/**
 * Notification badge component that displays unread count
 * @param {Object} props
 * @param {number} props.count - Unread notification count
 * @param {string} props.className - Additional CSS classes
 */
const NotificationBadge = ({ count, className = '' }) => {
  if (!count || count === 0) {
    return null;
  }

  const displayCount = count > 99 ? '99+' : count.toString();

  return (
    <div
      className={`absolute -top-1 left-full -translate-x-3 h-4 min-w-[16px] px-1 bg-[#FF5601] rounded-full flex items-center justify-center ${className}`}
    >
      <span className="text-white text-xs font-medium leading-none">
        {displayCount}
      </span>
    </div>
  );
};

export default NotificationBadge;
